<script>
import { memberDetailsMethods } from '@state/helpers/member-details'
import BasicInfo from '@views/MemberList/details/basic-info.vue'
import Answer from './details/answer.vue'
import Note from './details/note.vue'
import History from './details/history.vue'
export default {
  components: { BasicInfo, Answer, Note, History },
  page: {
    title: 'Detail Member',
    meta: [{ name: 'description', content: 'The Member detail page.' }],
  },
  data() {
    return {
      triggerMask: false,
    }
  },
  created() {
    this.getDetailMember()
  },
  methods: {
    ...memberDetailsMethods,
    getDetailMember() {
      this.getDetailsById({
        id: this.$route.params.id,
        agent_id: this.$route.params.agent_id,
      })
    },
    handleTriggerMask(value) {
      this.triggerMask = value
    },
  },
}
</script>

<template>
  <div>
    <CRow>
      <CCol lg="4">
        <BasicInfo :trigger-mask="triggerMask" />
      </CCol>
      <CCol lg="4">
        <Answer :trigger-mask="triggerMask" />
      </CCol>
      <CCol lg="4">
        <Note :trigger-mask="triggerMask" @edit-note="handleTriggerMask" />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <History :trigger-mask="triggerMask"></History>
      </CCol>
    </CRow>
  </div>
</template>
